export const getFieldsServiceUrl = (projectIdOrKey: number | string) =>
	`/rest/polaris/v2/projects/${projectIdOrKey}/fields/`;

export const getFieldsSearchServiceUrl = (projectIdOrKey: number | string) =>
	`/rest/polaris/v2/projects/${projectIdOrKey}/fields/customfields/search`;
